import React from 'react';

const DescriptionWithLinks = ({ description }) => {
   
    if (!description) {
        return;
    }
   
    const linkify = (text) => {
        const urlRegex = /((https?:\/\/|www\.)[^\s<>"']+)/gi;

        const parts = [];
        let lastIndex = 0;

        // Use regex.exec() to avoid duplication and get exact positions
        text.replace(urlRegex, (match, url, _, offset) => {
            // Push text before the match
            if (lastIndex < offset) {
                parts.push(text.slice(lastIndex, offset));
            }

            // Push the actual link
            const href = url.startsWith('http') ? url : `https://${url}`;
            parts.push(
                <a key={offset} href={href} target="_blank" rel="noopener noreferrer">
                    {url}
                </a>
            );

            lastIndex = offset + match.length;
            return match;
        });

        // Push any remaining text after the last match
        if (lastIndex < text.length) {
            parts.push(text.slice(lastIndex));
        }

        return parts;
    };

    return <p>{linkify(description)}</p>;
};

export default DescriptionWithLinks;